import {
  FormBasicsDto,
  FormQuestionDto,
  FormSectionDto,
} from "@green0meter/api-client";
import React, { FC, useRef } from "react";

import TableBody from "./components/TableBody";

import {
  Stack,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@components/base";
import { useDraftReturn } from "@hooks/useDraftField";

interface TableInput {
  formBasics?: FormBasicsDto;
  section?: FormSectionDto;
  question: FormQuestionDto;
  disabled?: boolean;
  draftField?: useDraftReturn | null;
}

const TableInput: FC<TableInput> = ({
  formBasics,
  section,
  question,
  disabled,
  draftField,
}) => {
  const tableRef = useRef<HTMLTableSectionElement>(null);

  return (
    <Stack spacing={2}>
      <div ref={tableRef}>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                {question.childQuestions?.map((childQuestion) => (
                  <TableCell key={childQuestion.questionId}>
                    {childQuestion.name}
                  </TableCell>
                ))}
                <TableCell />
              </TableRow>
            </TableHead>
            {formBasics && section && (
              <TableBody
                formId={formBasics.id}
                section={section}
                question={question}
                disabled={disabled}
                tableRef={tableRef}
                draftField={draftField}
              />
            )}
          </Table>
        </TableContainer>
      </div>
    </Stack>
  );
};

export default TableInput;
